export interface SearchUrlFields {
  engine?: string;
  site?: string;
  keywords?: string;
  domain?: string;
  phone?: string;
}

/**
 * Monta a URL de busca com o comportamento ativo do legado [api.js:192].
 *
 * Os antigos ramos por buscador, `source`, `track` e `num=100` estão comentados
 * na origem. Hoje apenas a URL-base varia; os operadores abaixo são comuns.
 */
export function forSearch(fields: SearchUrlFields): string {
  const engine = fields.engine ?? 'google';

  let url = 'https://www.google.com/search?q=';

  if (engine === 'bing') {
    url = 'https://www.bing.com/search?q=';
  } else if (engine === 'aol') {
    url = 'https://search.aol.com/search?q=';
  } else if (engine === 'yahoo') {
    url = 'https://br.search.yahoo.com/search?p=';
  }

  if (fields.site) {
    url += `site%3A${encodeURIComponent(fields.site.split('|')[0] ?? '')}+`;
  }

  if (fields.keywords) {
    url += `(${encodeURIComponent(fields.keywords)})+AND+`;
  }

  if (fields.domain) {
    const domains = fields.domain
      .split(';')
      .map((item) => item.split('|')[0] ?? '')
      .join('" OR "');
    url += `(%22${encodeURIComponent(domains)}%22)+`;
  }

  if (fields.phone) {
    url += `${fields.phone}+`;
  }

  return url;
}

/** Monta a URL do Google Maps com o comportamento do legado [api.js:532]. */
export function forMaps(
  fields: Pick<SearchUrlFields, 'keywords'>,
  geo?: string,
  name = '',
  language = '',
): string {
  let url = 'https://www.google.com/maps/search/';

  if (fields.keywords) {
    url += encodeURIComponent(fields.keywords);
  }

  if (geo) {
    if (language === 'ES') {
      url += ' cerca de ';
    } else if (language === 'FR') {
      url += ' près de ';
    } else if (language === 'PT') {
      url += ' próximo ';
    } else {
      url += ' near ';
    }
    url += `${name}/@${geo},15z/`;
  }

  return url;
}
